import {
  provideKeycloak,
  createInterceptorCondition,
    includeBearerTokenInterceptor,
  IncludeBearerTokenCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  withAutoRefreshToken,
  AutoRefreshTokenService,
  UserActivityService
} from 'keycloak-angular';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
//import { environment } from '../../../../environments/environment';

const localhostCdmCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /^(http:\/\/localhost:16322\/cdm)(\/.*)?$/i,
    bearerPrefix: 'Bearer'
});
const prodhostCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /^(https:\/\/api.sdf.ontollogix.cloud\/tams\/secure)(\/.*)?$/i,
    bearerPrefix: 'Bearer'
});
//any url with /cdm
const cdmCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /.*\/cdm(\/.*)?$/i,
    bearerPrefix: 'Bearer'
});
const ekcCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /.*\/ekc(\/.*)?$/i,
    bearerPrefix: 'Bearer'
});
const ldsCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /.*\/lds(\/.*)?$/i,
    bearerPrefix: 'Bearer'
});
const dusCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /.*\/dus(\/.*)?$/i,
    bearerPrefix: 'Bearer',
});
const dqmCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /.*\/dqm(\/.*)?$/i,
    bearerPrefix: 'Bearer',
});
const dqrCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /.*\/dqr(\/.*)?$/i,
    bearerPrefix: 'Bearer',
});
const nurvCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
    urlPattern: /.*\/nurv(\/.*)?$/i,
    bearerPrefix: 'Bearer',
});
const harvestorCondition =
    createInterceptorCondition<IncludeBearerTokenCondition>({
        urlPattern: /.*\/harvestor(\/.*)?$/i,
        bearerPrefix: 'Bearer',
    });

/**
 * The gateway's OWN endpoints, which carry no service prefix.
 *
 * Every condition above keys on a routed microservice's path segment (/ekc, /lds, ...) -- an
 * assumption that held until SDF2026-552 put a controller on the gateway itself. Nothing warns
 * you when it breaks: the request simply goes out with NO Authorization header (not an expired
 * one, none at all, which is why the browser sends no CORS preflight either), the gateway 401s,
 * and sessionExpiredInterceptor reloads the whole app -- which reads as a tab that will not open.
 *
 * The query string is matched optionally rather than relying on HttpRequest.url excluding params,
 * because ?refresh=true is a real parameter on this endpoint and losing the token to it would
 * fail the same silent way.
 */
const gatewayPlatformCondition =
    createInterceptorCondition<IncludeBearerTokenCondition>({
        urlPattern: /.*\/v1\/sdf\/platform(\/[^?]*)?(\?.*)?$/i,
        bearerPrefix: 'Bearer',
    });


export const provideKeycloakAngular = () =>
    provideKeycloak({
        config: {
            realm: 'SemanticDataFabric',
            url: environment.authUrl,
            clientId: 'KNIGHTGLY-UX-CLIENT',
        },
        initOptions: {
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri:
                window.location.origin + '/silent-check-sso.html',
            redirectUri: window.location.origin + '/',
            // Disabled: this polls a cross-origin session iframe every 5s and force-logs-out on
            // any non-'unchanged' response, independent of withAutoRefreshToken's activity-based
            // logic below -- browsers blocking third-party cookies break that check, causing
            // logouts during real activity. Token refresh is already handled proactively by
            // withAutoRefreshToken, so this iframe check is not needed for session liveness.
            checkLoginIframe: false,
        },
        features: [
            withAutoRefreshToken({
                onInactivityTimeout: 'logout', //action on inactivity
                // Was 900000 (15 min) -- shorter than Keycloak's own ssoSessionIdleTimeout (30 min,
                // realm-export-template.json), so a normal stretch of reading/filling a multi-step
                // wizard with no mouse/keyboard activity triggered a client-side logout well before
                // the actual SSO session expired server-side. Raised to 25 min, leaving a 5-min
                // safety margin under the server's idle timeout.
                sessionTimeout: 1500000, //session timeout in ms
            }),
        ],
        providers: [
            AutoRefreshTokenService,
            UserActivityService,
            {
                provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
                useValue: [
                    localhostCdmCondition,
                    cdmCondition,
                    prodhostCondition,
                    ekcCondition,
                    ldsCondition,
                    dusCondition,
                    dqmCondition,
                    dqrCondition,
                    nurvCondition,
                    harvestorCondition,
                    gatewayPlatformCondition,
                ],
            },
        ],
    });
